<template>
    <div class="bio" v-if="data && data.length">
        <div class="bio__section">
            <div class="row">
                <div
                    v-for="(item, i) in data"
                    :key="i"
                    class="bio__card col-default-4 col-v-tablet-6 col-mobile-12"
                >
                    <a
                        :href="buildDetailUrl(item.code)"
                        class="bio-item"
                    >
                        <div class="bio-item__image">
                            <img
                                v-if="item.previewPicture && item.previewPicture.link"
                                :src="item.previewPicture.link"
                                :alt="item.previewPicture.name"
                            >
                            <img v-else src="/images/biographies/imageholder.svg">
                        </div>
                        <div class="bio-item__name" v-if="item.name" v-html="item.name"></div>
                        <div class="bio-item__position" v-if="item.position.value" v-html="item.position.value"></div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'bio',
    props: {
        componentName: {
            type: String,
            validator: prop => ['board-of-management', 'board-of-directors'].includes(prop)
        }
    },
    data () {
        return {
            data: this.$root.app.components[this.componentName]
        }
    },
    methods: {
        buildDetailUrl (code) {
            return `/${this.$root.lang}/company/governance/${this.componentName === 'board-of-management' ? 'management' : 'board-of-directors'}/${code}/`
        }
    }
}
</script>

<style lang="scss" src="./index.scss"></style>
